module.exports = __webpack_public_path__ + "img/treatment-based-options-desktop-en.ffcc06b8.jpg";